import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Volume2, VolumeX } from 'lucide-react';
import { Switch } from './ui/switch';

import { getBackendUrl } from '../utils/getBackendUrl';
const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const LoginSoundToggle = () => {
  const [enabled, setEnabled] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/me/login-sound-pref`)
      .then((r) => {
        setEnabled(r.data.enabled !== false);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  const handleToggle = async (checked) => {
    setEnabled(checked);
    try {
      await axios.put(`${API}/me/login-sound-pref`, { enabled: checked });
      toast.success(checked ? 'Login sound on' : 'Login sound muted');
    } catch (e) {
      setEnabled(!checked);
      toast.error('Failed to update preference');
    }
  };

  return (
    <div className="glass-card p-4 mb-4" data-testid="login-sound-toggle-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-500/20 rounded-lg">
            {enabled ? (
              <Volume2 className="w-5 h-5 text-green-400" />
            ) : (
              <VolumeX className="w-5 h-5 text-slate-400" />
            )}
          </div>
          <div>
            <p className="font-semibold text-white">Login Sound</p>
            <p className="text-xs text-slate-400">Play a sound when you log in</p>
          </div>
        </div>
        <Switch
          checked={enabled}
          onCheckedChange={handleToggle}
          disabled={!loaded}
          data-testid="login-sound-pref-switch"
        />
      </div>
    </div>
  );
};

export default LoginSoundToggle;
